
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, Typography, ButtonBase } from '@material-ui/core';
import DateUtils from '../../../control/dateutils'
import Match from '../../../model/Match';
import AppData from '../../../model/AppData';

class MatchItemSimple extends React.Component {

    constructor(props) {
        super(props);
    }

    _onClicAnchor = (data) => {
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.type_id ? data.type_id : 0;
        let match_id = data.id ? data.id : 0;
        this.props.history.push({ pathname: '/play/' + room_id + '/' + match_type + '/' + match_id, data: data });
    }

    render() {
        const { data } = this.props;
        let match = new Match(data);
        let status = match.getStatus();
        let timer = DateUtils.dateFormatHM(data.match_time);
        let vs = match.getVs();
        let star = AppData.isStarMatch(match.type_id, match.id);
        return (
            <ButtonBase onClick={() => this._onClicAnchor(data)} >
                <Grid container justify='space-between' alignItems='center' direction='column' style={{ width: '100vw' }} >
                    <Grid container alignItems='center' justify='space-between' direction='row' style={{ flex: 1, marginTop: 8 }}>
                    </Grid>
                    <Grid container spacing={0} alignItems='center' justify='center' direction='row' style={{ marginTop: 16, marginBottom: 8 }}>
                        <Typography style={{ fontSize: 10, color: '#878787', marginLeft: 16 }}>{timer}</Typography>
                        <Grid container alignItems='center' justify='flex-end' direction='row' style={{ width: '30vw' }}>
                            <Typography noWrap={true} style={{ fontSize: 14, color: '#0D0D0D', marginRight: 8, maxWidth: 80 }}>{data.home_name}</Typography>
                        </Grid>
                        <Typography style={{ marginLeft: 8, marginRight: 8, fontSize: 13, color: '#0D0D0D' }}>{vs}</Typography>
                        <Grid container alignItems='center' justify='flex-start' direction='row' style={{ width: '30vw' }}>
                            <Typography noWrap={true} style={{ fontSize: 14, color: '#0D0D0D', marginLeft: 8, maxWidth: 80 }}>{data.away_name}</Typography>
                        </Grid>
                        <Typography style={{ fontSize: 10, color: '#878787', marginRight: 8 }}>{status}</Typography>
                    </Grid>
                    <Grid container alignItems='center' justify='center' direction='row'>
                        <Typography style={{ fontSize: 10, color: '#878787', marginBottom: 8 }}>{data.short_name_zh}</Typography>
                    </Grid>
                    <Grid style={{ width: '100%', height: 5, backgroundColor: '#F6F6F6' }}></Grid>
                </Grid>
            </ButtonBase>

        );
    }

}

export default withRouter(withStyles((theme) => ({

}))(MatchItemSimple));